import type { Nullable } from '../types';

export enum LocalStorageKeys {
  user = 'user',
}

export default class LocalStorageActions {
  static setItem(key: LocalStorageKeys, value: string): void {
    if (Object.values(LocalStorageKeys).includes(key))
      window.localStorage.setItem(key, value);
  }

  static getItem(key: LocalStorageKeys): Nullable<string> {
    if (!Object.values(LocalStorageKeys).includes(key)) return null;
    return window.localStorage.getItem(key);
  }

  static deleteItem(key: LocalStorageKeys): void {
    if (Object.values(LocalStorageKeys).includes(key))
      window.localStorage.removeItem(key);
  }
}
